import React from 'react';

export default function Box({ sectionData, title, body }) {
    // Parses the body text into list sections or paragraphs
    const parseBody = (text) => {
        const listRegex = /(\d+)\.\s+(.*?)(?=(\d+\.\s)|$)/gs;
        const parsed = [];
        let lastIndex = 0;

        const matches = [...text.matchAll(listRegex)];

        matches.forEach(match => {
            const [fullMatch, number, content] = match;
            const startIndex = match.index;

            // Non-list content before current list item
            if (startIndex > lastIndex) {
                const nonListText = text.slice(lastIndex, startIndex).trim();
                if (nonListText) {
                    if (nonListText.startsWith('Note:')) {
                        parsed.push({ type: 'paragraph', text: 'Note:' });
                        const rest = nonListText.slice(5).trim();
                        if (rest) parsed.push({ type: 'paragraph', text: rest });
                    } else {
                        parsed.push({ type: 'paragraph', text: nonListText });
                    }
                }
            }

            // Subitems (like a., b.)
            const subitemRegex = /([a-z])\.\s+(.*?)(?=(?:[a-z]\.\s)|$)/gis;
            const subitemMatches = [...content.matchAll(subitemRegex)];

            // let mainText = content;
            let subitems = [];

            if (subitemMatches.length > 0) {
                // mainText = content.slice(0, subitemMatches[0].index).trim();
                subitems = subitemMatches.map(m => ({
                    id: m[1].toLowerCase(),
                    text: m[2].trim(),
                }));
            }

            parsed.push({
                type: 'list',
                id: number,
                text: content.trim(),
                subitems,
            });

            lastIndex = startIndex + fullMatch.length;
        });

        // Remaining text after last list item
        const trailing = text.slice(lastIndex).trim();
        if (trailing) {
            if (trailing.startsWith('Note:')) {
                parsed.push({ type: 'paragraph', text: 'Note:' });
                const rest = trailing.slice(5).trim();
                if (rest) parsed.push({ type: 'paragraph', text: rest });
            } else {
                parsed.push({ type: 'paragraph', text: trailing });
            }
        }

        return parsed;
    };

    const renderContent = (parsed) => (
        <>
            {parsed.map((item, idx) => {
                if (item.type === 'paragraph') {
                    if (item.text.startsWith('•')) {
                        return (
                            <p key={idx} className={item.text === 'Note:' ? '' : 'paragraph df'}>
                                {/* <span className="bullet">•</span> */}
                                <span dangerouslySetInnerHTML={{ __html: item.text.replaceAll(' o ', '<br/>o ').replaceAll(' • ', '<br/><br/>• ').trim() }} />
                            </p>
                        );
                    } else {
                        return (
                            <p key={idx} className={item.text === 'Note:' ? '' : 'paragraph'}>
                                <span dangerouslySetInnerHTML={{ __html: item.text.replaceAll(' • ', '<br/>• ') }} />
                            </p>
                        );
                    }
                } else if (item.type === 'list') {
                    return (
                        <ul key={idx}>
                            <li>
                                <div className="first-li">
                                    <strong>{item.id}.</strong> <span>{item.text}</span>
                                </div>
                                {item.subitems.length > 0 && (
                                    <ul>
                                        {item.subitems.map((sub, subIdx) => {
                                            if (sub.text === '') return '';
                                            return <li key={subIdx}>
                                                <strong>{sub.id}.</strong> <span>{sub.text}</span>
                                            </li>
                                        })}
                                    </ul>
                                )}
                            </li>
                        </ul>
                    );
                } else {
                    return null;
                }
            })}
        </>
    );
    const parsedBody = body ? parseBody(body) : [];

    return (
        <div className={`box-container ${sectionData && (sectionData === 'start' ? ' first-box-of-section' : ' last-box-of-section')}`}>
            <div className="heading">{title || "None"}</div>
            <div className="body">
                {parsedBody.length > 0 ? renderContent(parsedBody) : 'none'}
            </div>
        </div>
    );
}
